import { tVariants } from '../../style-system';

const clickableProseImageStyles = tVariants({
    base: 'cursor-zoom-in',
    variants: {
        invertInLightMode: {
            true: 'light:invert light:brightness-90 light:hue-rotate-[180deg] light:saturate-[7] contrast-[1.1]',
            false: 'dark:invert dark:hue-rotate-[165deg] dark:saturate-150 dark:brightness-90',
        },
    },
});

const proseImgModalStyles = tVariants({
    base: 'fixed top-0 left-0 w-full h-full bg-surface flex justify-center items-center z-50',
    slots: {
        close: 'absolute top-0 right-0 p-4 z-50',
        content: 'max-w-90 max-h-90 overflow-hidden',
        image: 'w-full h-auto cursor-zoom-out',
    },
    defaultVariants: {
        invertInLightMode: false,
    },
    variants: {
        invertInLightMode: {
            true: {
                image: clickableProseImageStyles.variants.invertInLightMode.true,
            },
            false: {
                image: clickableProseImageStyles.variants.invertInLightMode.false,
            },
        },
    },
});

export { clickableProseImageStyles, proseImgModalStyles };
